
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Autocomplete, Button, Grid, MenuItem, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";

import { useCiudadesStore } from "../../../../store";
import { roles_select } from "../../../../data";
import { startSavingUsuario } from "../../../../services";
import Swal from "sweetalert2";




export const FormCreateUpdateUser = ({ initialState }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { startListadoCiudades, ciudades, startListadoRegiones, regiones } = useCiudadesStore();


    useEffect(() => {
        startListadoRegiones();
    }, [])



    const [formUser, setFormUser] = useState( initialState );
    const  { nombre, email, cedula, role, direccion, ciudad, movil, departamento } = formUser;
    const handleInputChange = ({ target }) => {
        setFormUser({
            ...formUser,
            [target.name]: target.value
        });
    }



    const handleChangeRegion = async (nombre) => {
        await startListadoCiudades(nombre);
        setFormUser(prev => ({ ...prev, departamento: nombre })); 
    };



    const handleCrearUsuario = async(e) => {
        e.preventDefault();
        if([nombre, email, role, direccion, ciudad, departamento, movil, cedula].includes('') ){
            return Swal.fire('Error', 'Formulario Incorrecto por favor llene todos los campos', 'error');
        }
        const resp = await startSavingUsuario( formUser );
        if(resp){
            if(!id) { setFormUser(initialState); }
            queryClient.invalidateQueries('usuarios-rol');
        }
    }


    return (

        <form onSubmit={ handleCrearUsuario } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre Completo'
                        type='text'
                        placeholder='Nombre Completo'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Cedula'
                        type='text'
                        placeholder='Cedula'
                        fullWidth
                        name='cedula'
                        value={ cedula }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Email'
                        type='email'
                        placeholder='Email'
                        fullWidth
                        name='email'
                        value={ email }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        select
                        label="Seleccione Role"
                        fullWidth
                        name='role'
                        value={ role }
                        onChange={ handleInputChange }
                    > 
                        <MenuItem value=''>Seleccione Role</MenuItem>
                        {roles_select.map( rol => (
                            <MenuItem key={rol} value={rol}>{rol}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Direccion'
                        type='text'
                        placeholder='Direccion'
                        fullWidth
                        name='direccion'
                        value={ direccion }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField 
                        label='Telefono'
                        type='number'
                        placeholder='Telefono'
                        fullWidth
                        name='movil'
                        value={ movil }
                        onChange={ handleInputChange }
                    />
                </Grid>

                {(regiones.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='departamento'
                        value={ regiones?.find(p => p.id === departamento) || null }
                        options={ regiones || [] }
                        onChange={(_, newValue) => handleChangeRegion(newValue.id)}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Departamento' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Departamento"
                    />
                </Grid>
                }

                {(ciudades.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='ciudad'
                        value={ ciudades?.find(p => p.id === ciudad) || null }
                        options={ ciudades || [] }
                        onChange={(_, newValue) => handleInputChange({ target:{name: 'ciudad', value: newValue.id || ''}})}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Ciudad' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Ciudad"
                    />
                </Grid>
                }

            </Grid>

            <Grid container sx={{mt:4, mb:2}} direccion='column'justifyContent='center'>
                <Grid item xs={12} sm={8} md={6}>
                    <Button variant='contained' fullWidth type='submit'>
                        {(id) ? 'Actualizar Usuario' : 'Crear Usuario'}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
